/**
 * SGKE361A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface FinalConfirmTab {

    /**
     * チラシ投函フラグ
     */
    flyerPostingFlg?: string;
    /**
     * 署名
     */
    signature?: string;
    /**
     * 署名区分
     */
    signatureDiv?: string;
}

